window.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);
    new SplitType("[text-split]", { types: "words, chars", tagName: "span", reduceWhiteSpace: !1 });
    function e(e, t) {
        ScrollTrigger.create({
            trigger: e,
            start: "top bottom",
            onLeaveBack: () => {
                t.progress(0), t.pause();
            },
        }),
            ScrollTrigger.create({ trigger: e, start: "top 60%", onEnter: () => t.play() });
    }
    document.querySelectorAll("[letters-slide-up-hero]").forEach((t) => {
        let o = gsap.timeline({ paused: !0 });
        o.from(t.querySelectorAll(".char"), {
            yPercent: 90,
            opacity: 0,
            duration: 0.2,
            delay: 2,
            ease: "power1.out",
            stagger: { amount: 0.2 },
        }),
            e(t, o);
    }),
        document.querySelectorAll("[box-animation-button]").forEach((e) => {
            let t = gsap.timeline({ paused: !0 });
            t.fromTo(e, { opacity: 0, width: "0vw" }, { opacity: 1, width: "auto", duration: 1, ease: "power4.out" }),
                ScrollTrigger.create({
                    trigger: e,
                    start: "top 80%",
                    end: "top 75%",
                    toggleActions: "play none none reverse",
                    animation: t,
                    once: !1,
                });
        }),
        document.querySelectorAll("[letters-slide-up-home-hero]").forEach((e) => {
            let t = gsap.timeline({ paused: !0 });
            t.from(e.querySelectorAll(".char"), {
                yPercent: 100,
                opacity: 0,
                duration: 0.4,
                delay: 0,
                ease: "power1.out",
                stagger: { amount: 0.4 },
            }),
                ScrollTrigger.create({
                    trigger: e,
                    start: "top 80%",
                    end: "top 60%",
                    toggleActions: "play none none reverse",
                    animation: t,
                    once: !1,
                });
        }),
        // document.querySelectorAll("[letters-slide-up]").forEach((t) => {
        //     let o = gsap.timeline({ paused: !0 });
        //     o.from(t.querySelectorAll(".char"), {
        //         yPercent: 100,
        //         duration: 0.3,
        //         opacity: 0,
        //         ease: "power1.out",
        //         stagger: { amount: 0.3 },
        //     }),
        //         e(t, o);
        // }),

     document.querySelectorAll("[letters-slide-up]").forEach((el) => {
  // You can target words instead of chars if SplitType added both
        const targets =
            el.querySelectorAll(".word").length > 0
            ? el.querySelectorAll(".word")
            : el.querySelectorAll(".char");

        if (!targets.length) return;

        gsap.set(targets, {
            display: "inline-block",
            y: "1em",
            opacity: 0,
            willChange: "transform, opacity",
        });

        ScrollTrigger.create({
            trigger: el,
            start: "top 92%", // start earlier
            end: "top 60%",
            toggleActions: "play reverse play reverse",
            onEnter: () => {
            gsap.to(targets, {
                y: "0em",
                opacity: 1,
                ease: "power2.out",
                duration: 0.5, // faster reveal
                stagger: { each: 0.015, from: "start" }, // very small delay between items
            });
            },
            onLeaveBack: () => {
            gsap.to(targets, {
                y: "1em",
                opacity: 0,
                ease: "power2.in",
                duration: 0.3,
                stagger: { each: 0.01, from: "end" },
            });
            },
        });
        });


        document.querySelectorAll("[scrub-each-word]").forEach((e) => {
            const t = e.querySelectorAll(".word");
            if (t.length) {
                gsap.timeline({ scrollTrigger: { trigger: e, start: "top 80%", end: "top 60%", scrub: !0 } }).from(
                    t,
                    { opacity: 0.1, color: "#FFFFFF", duration: 1, ease: "power1.out", stagger: { each: 0.2 } }
                );
            }
        }),
        document.querySelectorAll("[box-animation]").forEach((t) => {
            let o = gsap.timeline({ paused: !0 });
            o.fromTo(
                t,
                { opacity: 0, width: "0vw" },
                { opacity: 1, width: "auto", delay: 0, duration: 1, ease: "power4.out(1.7)" }
            ),
                e(t, o);
        }),
        document.querySelectorAll("[box-animation-delay-two]").forEach((t) => {
            let o = gsap.timeline({ paused: !0 });
            o.fromTo(
                t,
                { opacity: 0, width: "0vw" },
                { opacity: 1, width: "auto", delay: 0.2, duration: 1, ease: "power4.out(1.7)" }
            ),
                e(t, o);
        }),
        document.querySelectorAll("[box-animation-delay-three]").forEach((t) => {
            let o = gsap.timeline({ paused: !0 });
            o.fromTo(
                t,
                { opacity: 0, width: "0vw" },
                { opacity: 1, width: "auto", delay: 0.3, duration: 1, ease: "power4.out(1.7)" }
            ),
                e(t, o);
        }),
        document.querySelectorAll("[box-animation-new]").forEach((e) => {
            let t = gsap.timeline({ paused: !0 });
            t.fromTo(e, { opacity: 0, width: "0vw" }, { opacity: 1, width: "auto", duration: 1, ease: "power4.out" }),
                ScrollTrigger.create({
                    trigger: e,
                    start: "top 70%",
                    end: "top 30%",
                    toggleActions: "play none none reverse",
                    animation: t,
                    once: !1,
                });
        }),
        gsap.set("[text-split]", { opacity: 1 });
        const t = new Lenis({
            duration: 1.2,
            easing: (e) => Math.min(1, 1.001 - Math.pow(2, -10 * e)),
            direction: "vertical",
            gestureDirection: "vertical",
            smooth: !1,
            mouseMultiplier: 0.8,
            smoothTouch: !1,
            touchMultiplier: 1,
            infinite: !1,
        });

 

    requestAnimationFrame(function e(o) {
        t.raf(o), requestAnimationFrame(e);
    }),
    t.on("scroll", ScrollTrigger.update);

});
